import { useState, useEffect, useRef } from 'react';

export default function CountUp({ value, duration = 1600, className }) {
  const [display, setDisplay] = useState('0');
  const [visible, setVisible] = useState(false);
  const startedRef = useRef(false);
  const elRef = useRef(null);

  const match = value.match(/^([^\d-]*)?(-?[\d.]+)(.*)$/);
  const prefix = match?.[1] || '';
  const target = parseFloat(match?.[2] || '0');
  const suffix = match?.[3] || '';
  const decimals = (match?.[2] || '').includes('.') ? (match?.[2].split('.')[1] || '').length : 0;

  useEffect(() => {
    if (!elRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.3 }
    );
    observer.observe(elRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible || startedRef.current) return;
    startedRef.current = true;
    let start = null;
    let raf;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const current = target * eased;
      setDisplay(current.toFixed(decimals));
      if (progress < 1) {
        raf = requestAnimationFrame(step);
      } else {
        setDisplay(target.toFixed(decimals));
      }
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [visible]);

  return <span ref={elRef} className={className}>{prefix}{display}{suffix}</span>;
}